"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchRequest = void 0;
var shared_1 = require("@cian/peperrors/shared");
var Response_1 = require("./Response");
var FetchRequest = /** @class */ (function () {
    function FetchRequest(params) {
        this.isDestroyed = false;
        this.requestConfig = params.requestConfig;
        this.timeout = params.timeout;
        this.requestServerName = params.requestServerName;
    }
    FetchRequest.prototype.send = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, url, method, headers, withCredentials, body, credentials, stringUri, reqParams, req, timeout, res, error_1, err;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.requestConfig, url = _a.url, method = _a.method, headers = _a.headers, withCredentials = _a.withCredentials, body = _a.body;
                        credentials = withCredentials ? 'include' : 'same-origin';
                        this.abortController = new AbortController();
                        if (this.abortRequestReason) {
                            this.abortController.abort();
                        }
                        stringUri = url.toString();
                        reqParams = {
                            method: method,
                            headers: headers.toArray(),
                            credentials: credentials,
                            signal: this.abortController.signal,
                        };
                        if (method === 'POST') {
                            reqParams.body = body;
                        }
                        req = new Request(stringUri, reqParams);
                        timeout = setTimeout(function () {
                            return _this.destroy(new shared_1.HttpTimeoutError("Microservice ".concat(_this.requestServerName, " api ").concat(stringUri, " not answers in ").concat(_this.timeout, " milliseconds"), "http-api.request-timeout.".concat(_this.requestServerName)));
                        }, this.timeout);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetch(req)];
                    case 2:
                        res = _b.sent();
                        clearTimeout(timeout);
                        return [2 /*return*/, new Response_1.Response({
                                reqConfig: this.requestConfig,
                                rawHeaders: res.headers,
                                response: res,
                                statusCode: res.status,
                            })];
                    case 3:
                        error_1 = _b.sent();
                        clearTimeout(timeout);
                        if (error_1.name === 'AbortError') {
                            if (this.abortRequestReason) {
                                throw this.abortRequestReason;
                            }
                            err = new shared_1.UnknownError({
                                message: error_1.message,
                                domain: "http-api.FetchRequest.".concat(this.requestServerName),
                            });
                            err.name = 'AbortError';
                            throw err;
                        }
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FetchRequest.prototype.destroy = function (cause) {
        if (cause) {
            this.abortRequestReason = cause;
        }
        if (this.abortController) {
            this.isDestroyed = true;
            this.abortController.abort();
        }
    };
    return FetchRequest;
}());
exports.FetchRequest = FetchRequest;
//# sourceMappingURL=FetchRequest.js.map